import { ActDomainManagmentFiltersForm } from 'civil-status/view-models/act-domain-managment-list';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValues: ActDomainManagmentFiltersForm = {
  domainType: '',
  domainName: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageDomainManagementInitializer = (): React.ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageDomainManagementInitializer.displayName = 'Page domain-management initializer component';

export default PageDomainManagementInitializer;
